import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '@/app/providers/auth-provider.js';
import { appPaths } from '@/app/router/paths.js';
import { canMutateGeoCities } from '@/features/identity/geo-catalog-access.js';

export function RequireGeoCityCatalog({ children }: { children: ReactNode }) {
  const { status, user } = useAuth();

  if (status === 'loading') {
    return null;
  }

  if (status !== 'authenticated' || !user) {
    return <Navigate to={appPaths.login} replace />;
  }

  const isPlatform = user.activeContext?.scopeType === 'SYSTEM';
  if (!isPlatform && !canMutateGeoCities(user.roles)) {
    return <Navigate to={appPaths.home} replace />;
  }

  return children;
}
